var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    [
      _c(
        "v-flex",
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                [
                  _c("h3", { staticClass: "headline mb-0 admin-header" }, [
                    _vm._v("Audit History"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", icon: "", color: "grey lighten-1" },
                      on: {
                        click: function ($event) {
                          return _vm.refresh(_vm.pagination)
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("fas fa-sync")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("span", { staticClass: "subheading" }, [
                        _c("b", [_vm._v("Filters:")]),
                      ]),
                      _vm._v(" "),
                      _vm.showFilters
                        ? _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = !_vm.showFilters
                                },
                              },
                            },
                            [_vm._v("fal fa-chevron-up")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showFilters
                        ? _c(
                            "v-icon",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = !_vm.showFilters
                                },
                              },
                            },
                            [_vm._v("fal fa-chevron-down")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showFilters
                    ? _c(
                        "v-form",
                        {
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                          model: {
                            value: _vm.valid,
                            callback: function ($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid",
                          },
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs11: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { wrap: "" } },
                                    [
                                      !_vm.orgIdProp
                                        ? _c(
                                            "v-flex",
                                            { attrs: { xs2: "", "ml-4": "" } },
                                            [
                                              _c("v-autocomplete", {
                                                attrs: {
                                                  items: _vm.organizations,
                                                  label: "Organization",
                                                  "item-text": "text",
                                                  "item-value": "value",
                                                },
                                                model: {
                                                  value: _vm.orgId,
                                                  callback: function ($$v) {
                                                    _vm.orgId = $$v
                                                  },
                                                  expression: "orgId",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "User Id" },
                                            model: {
                                              value: _vm.userId,
                                              callback: function ($$v) {
                                                _vm.userId = $$v
                                              },
                                              expression: "userId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Entity Id" },
                                            model: {
                                              value: _vm.entityId,
                                              callback: function ($$v) {
                                                _vm.entityId = $$v
                                              },
                                              expression: "entityId",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Entity Name",
                                              items: _vm.entityNames,
                                            },
                                            model: {
                                              value: _vm.entityName,
                                              callback: function ($$v) {
                                                _vm.entityName = $$v
                                              },
                                              expression: "entityName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              label: "Event Type",
                                              items: _vm.eventTypes,
                                            },
                                            model: {
                                              value: _vm.eventType,
                                              callback: function ($$v) {
                                                _vm.eventType = $$v
                                              },
                                              expression: "eventType",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "", "ml-4": "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "Text" },
                                            model: {
                                              value: _vm.text,
                                              callback: function ($$v) {
                                                _vm.text = $$v
                                              },
                                              expression: "text",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs4: "", "ml-4": "" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "date-time-container",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "date-selection-wrapper",
                                                },
                                                [
                                                  _c("date-selection", {
                                                    attrs: {
                                                      "min-date": _vm.minDate,
                                                      "max-date": _vm.maxDate,
                                                      "date-text": _vm.dateText,
                                                      value: _vm.dateValue,
                                                    },
                                                    on: {
                                                      "range-selected":
                                                        _vm.handleDateRangeUpdate,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-flex", { attrs: { xs1: "" } }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: {
                                      onsubmit: "false",
                                      disabled: !_vm.valid,
                                    },
                                    on: { click: _vm.applyFilters },
                                  },
                                  [_vm._v("Apply")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default",
                                    attrs: { onsubmit: "false" },
                                    on: { click: _vm.resetFilters },
                                  },
                                  [_vm._v("Reset")]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              items: _vm.auditHistory.content,
                              loading: _vm.loading,
                              headers: _vm.headers,
                              options: _vm.pagination,
                              "footer-props": {
                                "items-per-page-options": [
                                  5, 10, 15, 20, 50, 100,
                                ],
                              },
                              "server-items-length": _vm.totalItems,
                            },
                            on: {
                              "update:options": function ($event) {
                                _vm.pagination = $event
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.updatedDate",
                                  fn: function ({ item }) {
                                    return [
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatDateTime(item.updatedDate)
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                                !_vm.orgIdProp
                                  ? {
                                      key: "item.orgId",
                                      fn: function ({ item }) {
                                        return [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.org ? item.org.id : null
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    }
                                  : null,
                                !_vm.orgIdProp
                                  ? {
                                      key: "item.orgName",
                                      fn: function ({ item }) {
                                        return [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                item.org ? item.org.name : null
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    }
                                  : null,
                                {
                                  key: "item.userId",
                                  fn: function ({ item }) {
                                    return [
                                      _c("td", [_vm._v(_vm._s(item.userId))]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.entityId",
                                  fn: function ({ item }) {
                                    return [
                                      _c("td", [_vm._v(_vm._s(item.entityId))]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.entityName",
                                  fn: function ({ item }) {
                                    return [
                                      _c("td", [
                                        _vm._v(_vm._s(item.entityName)),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.eventType",
                                  fn: function ({ item }) {
                                    return [
                                      _c("td", [
                                        _vm._v(_vm._s(item.eventType)),
                                      ]),
                                    ]
                                  },
                                },
                                {
                                  key: "item.text",
                                  fn: function ({ item }) {
                                    return [
                                      _c("td", [_vm._v(_vm._s(item.text))]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }